<template>

<div class="Data_V_Border">
  <div id="Data_V">

    <div class="Title">
      <img :src="Logo" alt="">
      <div v-if="!$route.query.courseName"> {{ planName }} 评阅实时播报 </div>
      <div v-else> {{ planName }}评阅实时播报 — {{$route.query.courseName}}</div>
      <div class="Date">
        <span>{{ YMD }}</span>
        <span>{{ HIS }}</span>
      </div>
    </div>

    <div class="Top">
      <!-- 数据总览 -->
      <div class="Top_title">
        <div class="title_A"></div>
        <div class="title_B">数据总览</div>
      </div>
      <div class="Top_main">
        <!-- 考试课程 -->
        <div class="item item_D" v-if="!$route.query.courseId">
          <div class="item_dule">
            <span>
              <CountTo :startVal="courseNum.start" :endVal="courseNum.end" :duration="courseNum.duration"></CountTo>
            </span>
            <span>门</span>
          </div>
          <div class="item_des"> 考试课程 </div>
        </div>
        <!-- 评阅教师 -->
        <div class="item item_D">
          <div class="item_dule">
            <span>
              <CountTo :startVal="teacherNum.start" :endVal="teacherNum.end" :duration="teacherNum.duration"></CountTo>
            </span>
            <span>人</span>
          </div>
          <div class="item_des"> 评阅教师 </div>
        </div>
        <!-- 报考人次 -->
        <div class="item item_D">
          <div class="item_dule">
            <span>
              <CountTo :startVal="signNum.start" :endVal="signNum.end" :duration="signNum.duration"></CountTo>
            </span>
            <span></span>
          </div>
          <div class="item_des"> 报考人次 </div>
        </div>
        <!-- 实考人次 -->
        <div class="item item_D">
          <div class="item_dule">
            <span>
              <CountTo :startVal="examNum.start" :endVal="examNum.end" :duration="examNum.duration"></CountTo>
            </span>
            <span></span>
          </div>
          <div class="item_des"> 实考人次 </div>
        </div>
        <!-- 实考已分配 -->
        <div class="item item_D">
          <div class="item_dule">
            <span>
              <CountTo :startVal="examAssignNum.start" :endVal="examAssignNum.end" :duration="examAssignNum.duration"></CountTo>
            </span>
            <span>份</span>
          </div>
          <div class="item_des"> 实考已分配 </div>
        </div>
        <!-- 实考未分配 -->
        <div class="item item_D">
          <div class="item_dule">
            <span>
              <CountTo :startVal="examUnAssignNum.start" :endVal="examUnAssignNum.end" :duration="examUnAssignNum.duration"></CountTo>
            </span>
            <span>份</span>
          </div>
          <div class="item_des"> 实考未分配 </div>
        </div>
        <!-- 已评阅 -->
        <div class="item item_D">
          <div class="item_dule">
            <span>
              <CountTo :startVal="reviewNum.start" :endVal="reviewNum.end" :duration="reviewNum.duration"></CountTo>
            </span>
            <span>份</span>
          </div>
          <div class="item_des"> 已评阅 </div>
        </div>
        <!-- 待评阅 -->
        <div class="item item_D">
          <div class="item_dule">
            <span>
              <CountTo :startVal="unReviewNum.start" :endVal="unReviewNum.end" :duration="unReviewNum.duration"></CountTo>
            </span>
            <span>份</span>
          </div>
          <div class="item_des"> 待评阅 </div>
        </div>
      </div>
    </div>

    <!-- Middle -->
    <div class="Middle">

      <!-- Middle ==> Left -->
      <div class="Left">
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B"> {{ $route.query.courseId ? '评阅分配总概' : '评阅分配统计' }} </div>
          </div>
        </div>
        <div class="charts">
          <!-- E-charts => A -->
          <div class="chart_A">
            <div class="chart_A_Border">
              <div id="chart_A"></div>
            </div>
            <div class="info_Mob">
              <div class="dit" style="background: #023AFF"></div>
              <span>实考已分配</span>
              <span class="number"> 
                <CountTo :startVal="examAssignNum.start" :endVal="examAssignNum.end" :duration="examAssignNum.duration"></CountTo>
              </span>
              <span>份</span>
            </div>
            <div class="info_Web">
              <div class="dit" style="background: #8000FF"></div>
              <span>实考未分配</span>
              <span class="number"> 
                <CountTo :startVal="examUnAssignNum.start" :endVal="examUnAssignNum.end" :duration="examUnAssignNum.duration"></CountTo>
              </span>
              <span>份</span>
            </div>
          </div>
          <!-- E-charts => B -->
          <div class="chart_B">
            <div class="chart_B_Border">
              <div id="chart_B"></div>
            </div>
            <div class="info_Mob">
              <div class="dit" style="background: #05C985"></div>
              <span>已评阅</span>
              <span class="number"> 
                <CountTo :startVal="reviewNum.start" :endVal="reviewNum.end" :duration="reviewNum.duration"></CountTo>
              </span>
              <span>份</span>
            </div>
            <div class="info_Web">
              <div class="dit" style="background: #FFA63E"></div>
              <span>待评阅</span>
              <span class="number">
                <CountTo :startVal="unReviewNum.start" :endVal="unReviewNum.end" :duration="unReviewNum.duration"></CountTo>
              </span>
              <span>份</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Middle ==> Center -->
      <div class="Center" style="margin-left: .08rem;">
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B">日评阅量统计 <span v-show="teacherInfo.courseName && !$route.query.courseId">（ {{teacherInfo.courseName}} ）</span>  </div>
          </div>
          <div class="title_C">单位：份</div>
        </div>
        <div id="chart_C"></div>
      </div>

      <!-- Middle ==> Right -->
      <div class="Right" style="margin-left: .08rem">
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B">{{ $route.query.courseId ? '实时阅卷情况': '评阅分数段分布' }} <span v-show="data_D_course && !$route.query.courseId">（ {{ data_D_course }} ）</span></div>
          </div>
        </div>
        <div id="chart_D" v-show="!$route.query.courseId"></div>

        <div v-show="$route.query.courseId">
          <div class="Scroll">
            <vueSeamlessScroll :data="ReviewList" class="VueScoll" :class-option="{step: .5, limitMoveNum: 7, hoverStop: false}">
              <ul>
                <li
                  v-for="(item, index) in ReviewList"
                  :key="index"
                >
                  <div class="A"> {{ item.reviewTime }} </div>
                  <div class="B"> {{ item.teacherName }} 阅完1份试卷</div>
                  <div class="C"> 当日共评阅 <span style="color: #00D86C;">{{ item.reviewCount }}</span> 份</div>
                </li>
              </ul>
            </vueSeamlessScroll>
          </div>
        </div>

      </div>
    </div>

    <!-- Bottom -->
    <div class="Bottom">

      <div class="Left">
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B"> {{ $route.query.courseId ? '评阅教师工作进度' : '评阅分配详情'}} </div>
          </div>
          <div class="title_C">单位：份</div>
        </div>
        <div class="charts">
          <div id="chart_E"></div>
        </div>
      </div>

      <div class="Center" style="margin-left: .08rem">
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B">评阅平均时长统计</div>
          </div>
          <div class="title_C">单位：秒/份</div>
        </div>
        <div class="charts">
          <div id="chart_F"></div>
        </div>

      </div>

      <div class="Right" style="margin-left: .08rem">
        <div class="title">
          <div>
            <div class="title_A"></div>
            <div class="title_B"> {{ !$route.query.courseId ? '实时阅卷情况': '评阅分数段分布' }} </div>
          </div>
          <div class="title_C" v-show="$route.query.courseId">单位：份</div>
        </div>

        <div class="charts" v-show="$route.query.courseId">
          <div id="chart_G"></div>
        </div>

        <div v-show="!$route.query.courseId">
          <div class="Scroll">
            <vueSeamlessScroll :data="ReviewList" class="VueScoll" :class-option="{step: .5, limitMoveNum: 7, hoverStop: false}">
              <ul>
                <li
                  v-for="(item, index) in ReviewList"
                  :key="index"
                >
                  <div class="A"> {{ item.reviewTime }} </div>
                  <div class="B"> {{ item.teacherName }} 阅完1份试卷</div>
                  <div class="C"> 当日共评阅 <span style="color: #00D86C;">{{ item.reviewCount }}</span> 份</div>
                </li>
              </ul>
            </vueSeamlessScroll>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>

</template>

<script>
import CountTo from 'vue-count-to'
import vueSeamlessScroll from "vue-seamless-scroll"
import { getScreenReviewInfoListApi, getScreenReviewTotalApi, getScreenReviewDateCountApi, getScreenReviewCourseListApi, getScreenReviewCountListApi, getScreenReviewDurationListApi, getScreenReviewScoreSectionApi } from '@/http/modules/dataV.js'
               
export default {
  components: {
    CountTo,
    vueSeamlessScroll
  },
  data() {
    return {
      LogoImg: require("@/assets/img/customDefault.png"),   // Logo
      YMD: '',    // Date YY-MM-DD
      HIS: '',    // Date HH-MM-SS
      colorList: ['#023AFF', '#FFA63E', '#00D86C', '#7300E6', '#EE423D', '#266EFF'],  // 颜色组

      // setInterval
      interval_A: '',
      interval_B: '',
      interval_C: '',
      interval_D: '',
      interval_E: '',
      interval_F: '',
      interval_G: '',

      interval_initData: '',
      interval_getTeacher: '',
      interval_data_C: '',
      interval_Duration: '',
      interval_location: '',
      interval_Score: '',
      interval_Review: '',
      // E-charts Data
      data_A: [],
      data_B: [],
      data_C: [],
      data_C_Index: 0,
      data_D: [],
      data_D_name: '',
      data_D_course: '',
      data_D_Index: 0,
      data_E: [],
      data_E_Course_Index: 0,
      data_E_Index: 0,
      data_F: [],
      data_F_Duration_Index: 0,
      data_F_Index: 0,
      data_G: [],

      // 实时阅卷滚动列表
      ReviewList: [],

      // 阅卷数据总览
      Info: {},

      // 考试课程
      courseNum: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 评阅教师
      teacherNum: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 报考人次
      signNum: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 实考人次
      examNum: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 实考已分配
      examAssignNum: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 实考未分配
      examUnAssignNum: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 已评阅
      reviewNum: {
        start: 0,
        end: 0,
        duration: 3000
      },
      // 待评阅
      unReviewNum: {
        start: 0,
        end: 0,
        duration: 3000
      },

      Logo: "",

      // 批次信息
      planId: this.$route.query.planId,
      courseId: this.$route.query.courseId,
      planName: this.$route.query.planName,

      start_ECharts: true,
      // 教师
      teacherList: [],
      teacherInfo: {},
    }
  },

  methods: {
    /**
     * @param { Logo }
     */
    getLogo(){
      let tenant = window.localStorage.getItem('tenant')
      let defaultLogo = require("@/assets/img/customDefault.png")
      this.$api.system.getSystemNameFN({tenant}).then(({data})=>{
        this.Logo = data.isUsedLogo == 1 ? data.logoUrl ? data.logoUrl : defaultLogo : defaultLogo
      })
    },

    /**
     * @param { 时间 YMD-HIS }
     */
    currentDate() {
      let that = this
      let nowTime = function() {
        that.YMD = current_YMD()
        that.HIS = current_HIS()
      }
      function twoDigits (val) {
        if (val < 10) return '0' + val
        return val
      }
      function current_YMD() {
        let date = new Date()
        let YMD = date.getFullYear() + '年' + twoDigits(date.getMonth() + 1) + '月' + twoDigits(date.getDate()) + '日'
        return YMD
      }
      function current_HIS() {
        let date = new Date()
        let HIS = twoDigits(date.getHours()) + ':' + twoDigits(date.getMinutes()) + ':' + twoDigits(date.getSeconds())
        return HIS
      }
      this.currentTime = setInterval(nowTime, 1000)
    },

    /**
     * @param { 数字格式 }
     */
    setNumber(p) {
      let value = ''
      if (p.value >= 0) {
        value = p.value
        if (value > 999) {
          let parts = value.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          value = parts.join('.')
        }
      }
      return value
    },

    /**
     * @param { 日评阅量统计 => 五秒一屏 }
     * @param { 评阅分配详情 => 五秒一屏 }
     */
    async getTeacherList() {
      let that = this

      // ** 数组格式转换
      const division = (arr, num) => {
        let newArr = []
        return arr.reduce(function(pre, item, index, arr){
          var begin = index * num
          var end = begin + num
          var res = arr.slice(begin, end)
          if (res.length != 0) {
            newArr[index] = res
          }
          return newArr
        }, [])
      }

      // ** 避免定时错误, 优先清理一次
      clearInterval(this.interval_getTeacher)
      clearInterval(this.interval_data_C)
      clearInterval(this.interval_location)
      clearInterval(this.interval_Duration)
      clearInterval(this.interval_Score)
      clearInterval(this.interval_Review)
      // (1) 教师列表
      let { data } = await getScreenReviewCourseListApi({ planId: this.planId, courseId: this.courseId})
      this.teacherList = data
      let time = data.length > 0 ? data.length * 30000 : 30000
      this.interval_getTeacher = setInterval(async () => {
        let { data } = await getScreenReviewCourseListApi({ planId: that.planId, courseId: that.courseId})
        that.teacherList = data
      }, time)

      // (2) 日评阅量统计 (E-charts C)
      let param = {
        planId: this.planId,
        courseId: this.courseId ? this.courseId : this.teacherList.length > 0 ? this.teacherList[this.data_C_Index].courseId : '',
        teacherId: this.teacherList.length > 0 ? this.teacherList[this.data_C_Index].teacherId : ''
      }
      let res = await getScreenReviewDateCountApi(param)
      let teacherName = this.teacherList.length > 0 ? this.teacherList[this.data_C_Index].teacherName : '暂无'
      this.teacherInfo = res.data
      this.teacherInfo.teacherName = teacherName
      this.teacherInfo.courseName = this.teacherList[this.data_C_Index].courseName

      this.interval_data_C = setInterval(async () => {
        that.data_C_Index++
        if (that.data_C_Index == that.teacherList.length || that.data_C_Index > that.teacherList.length) {
          that.data_C_Index = 0
        }
        let param = {
          planId: that.planId,
          courseId: that.courseId ? that.courseId : that.teacherList.length > 0 ? that.teacherList[that.data_C_Index].courseId : '',
          teacherId: that.teacherList.length > 0 ? that.teacherList[that.data_C_Index].teacherId : ''
        }
        let res = await getScreenReviewDateCountApi(param)
        let teacherName = that.teacherList.length > 0 ? that.teacherList[that.data_C_Index].teacherName : '暂无'
        that.teacherInfo = res.data
        that.teacherInfo.teacherName = teacherName
        that.teacherInfo.courseName = that.teacherList[that.data_C_Index].courseName
      }, 30000)

      // (3) 评阅分配详情 (E-charts E)
      let locationTime = Math.ceil(this.teacherList.length / 4) == 0 ? 30000 : Math.ceil(this.teacherList.length / 4) * 30000
      let locationList = await getScreenReviewCountListApi({planId: param.planId, courseId: this.courseId })
      this.data_E = division(locationList.data, 4)
      this.interval_location = setInterval(async () => {
        let locationList = await getScreenReviewCountListApi({ planId: that.planId, courseId: that.courseId })
        that.data_E = division(locationList.data, 4)
      }, locationTime)

      // (4) 评阅平均时长统计 (E-charts F)
      let DurationList = await getScreenReviewDurationListApi({ planId: this.planId, courseId: this.courseId })
      let DurationTime = Math.ceil(DurationList.data.length / 4) == 0 ? 30000 : Math.ceil(DurationList.data.length / 4) * 30000
      this.data_F = division(DurationList.data, 4)
      this.interval_Duration = setInterval(async () => {
        let DurationList = await getScreenReviewDurationListApi({ planId: that.planId, courseId: that.courseId })
        that.data_F = division(DurationList.data, 4)
      }, DurationTime)

      // (5) 评阅分数段分布 (课程) (E-charts D)
      let scoreParam = {
        planId: this.planId,
        courseId: this.teacherList.length > 0 ? this.teacherList[0].courseId : '',
        reviewNum: this.teacherList.length > 0 ? this.teacherList[0].reviewNum : '',
        teacherId: this.teacherList.length > 0 ? this.teacherList[0].teacherId : '',
        totalScore: this.teacherList.length > 0 ? this.teacherList[0].totalScore: ''
      }
      let ScoreList = await getScreenReviewScoreSectionApi(scoreParam)
      this.data_D = ScoreList.data
      this.data_D_name = this.teacherList.length > 0 ? this.teacherList[0].teacherName: '暂无'
      this.data_D_course = this.teacherList.length > 0 ? this.teacherList[0].courseName: ''
      this.interval_Score = setInterval(async () => {
        that.data_D_Index++
        if (that.data_D_Index >= that.teacherList.length) {
          that.data_D_Index = 0
        }
        scoreParam.courseId = that.teacherList.length > 0 ? that.teacherList[that.data_D_Index].courseId : ''
        scoreParam.reviewNum = that.teacherList.length > 0 ? that.teacherList[that.data_D_Index].reviewNum : ''
        scoreParam.teacherId = that.teacherList.length > 0 ? that.teacherList[that.data_D_Index].teacherId : ''
        scoreParam.totalScore = that.teacherList.length > 0 ? that.teacherList[that.data_D_Index].totalScore : ''
        let ScoreList = await getScreenReviewScoreSectionApi(scoreParam)
        that.data_D = ScoreList.data
        that.data_D_name = that.teacherList.length > 0 ? that.teacherList[that.data_D_Index].teacherName : '暂无'
        that.data_D_course = that.teacherList.length > 0 ? that.teacherList[that.data_D_Index].courseName: ''
      }, 30000)

      // (6) 实时阅卷情况
      let ReviewList = await getScreenReviewInfoListApi({ planId: this.planId, courseId: this.courseId })
      this.ReviewList = ReviewList.data
      this.interval_Review = setInterval( async () => {
        let ReviewList = await getScreenReviewInfoListApi({ planId: that.planId, courseId: that.courseId })
        that.ReviewList = ReviewList.data
      }, 30000);

    },

    /**
     * @param { 数据总览 }
     */
    async initData() {
      // 当前批次数据
      let planId = this.planId
      let courseId = this.courseId

      // 初始化翻牌数据
      this.courseNum.end = 0
      this.teacherNum.end = 0
      this.signNum.end = 0
      this.examNum.end = 0
      this.examAssignNum.end = 0
      this.examUnAssignNum.end = 0
      this.reviewNum.end = 0
      this.unReviewNum.end = 0

      let { data } = await getScreenReviewTotalApi({planId, courseId})
      this.Info = data
      this.courseNum.start = 0
      this.courseNum.end = data.courseNum
      this.teacherNum.start = 0
      this.teacherNum.end = data.teacherNum
      this.signNum.start = 0
      this.signNum.end = data.signNum
      this.examNum.start = 0
      this.examNum.end = data.examNum
      this.examAssignNum.start = 0
      this.examAssignNum.end = data.examAssignNum
      this.examUnAssignNum.start = 0
      this.examUnAssignNum.end = data.examUnAssignNum
      this.reviewNum.start = 0
      this.reviewNum.end = data.reviewNum
      this.unReviewNum.start = 0
      this.unReviewNum.end = data.unReviewNum

      if (this.start_ECharts) {
        this.start_ECharts = !this.start_ECharts
        this.initECharts()
      }
    },

    /**
     * @param { E-charts 数据处理 }
     */
    initECharts() {
      this.DrawECharts()
    },

    /**
     * @param { E-charts }
     */
    async DrawECharts() {
      await this.chart_A();
      await this.chart_B();
      await this.chart_C();
      await this.chart_D();
      await this.chart_E();
      await this.chart_F();
      await this.chart_G();
    },

    /**
     * @param { 评阅分配统计 }
     */
    chart_A() {
      let that = this

      let data = [
        { value: this.Info.examAssignNum },
        { value: this.Info.examUnAssignNum }
      ]

      let myChart = this.$echarts.init(document.getElementById("chart_A"))
      var option = {
        series: [
          {
            type: 'pie',
            radius: ['65%', '100%'],
            hoverAnimation: false,
            label: {
              show: true,
              position: 'center',
              formatter: `{total|分配统计}`,
              rich: {
                total: {
                  fontSize: 14,
                  lineHeight: 16,
                  fontWeight: 500,
                  color: "#FFF",
                  fontFamily: 'PingFangSC-Regular, PingFang SC'
                }
              },
            },
            itemStyle: {
              normal: {
                color: function(colors) {
                  let list = ['#023AFF', '#8000FF']
                  return list[colors.dataIndex]
                }
              }
            },
            data,
          }
        ]
      }
      option && myChart.setOption(option)

      clearInterval(this.interval_A)
      this.interval_A = setInterval(() => {

        clearTimeout(timer)
        let timer = setTimeout(function(){

          document.getElementById('chart_A').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_A"))

          let data = [
            { value: that.Info.examAssignNum },
            { value: that.Info.examUnAssignNum }
          ]

          option.series[0].data = data
          option && myChart.setOption(option)
        }, 100)

      }, 30000)

    },

    /**
     * @param { 评阅分配详情 }
     */
    chart_B() {
      let that = this
      let myChart = this.$echarts.init(document.getElementById("chart_B"))

      var option = {
        series: [
          {
            type: 'pie',
            radius: ['65%', '100%'],
            hoverAnimation: false,
            label: {
              show: true,
              position: 'center',
              formatter: `{total|评阅统计}`,
              rich: {
                total: {
                  fontSize: 14,
                  lineHeight: 16,
                  fontWeight: 500,
                  color: "#FFF",
                  fontFamily: 'PingFangSC-Regular, PingFang SC'
                }
              },
            },
            itemStyle: {
              normal: {
                color: function(colors) {
                  let list = ['#00D86C', '#FFA63E']
                  return list[colors.dataIndex]
                }
              }
            },
            data: [
              { value: that.Info.reviewNum },
              { value: that.Info.unReviewNum },
            ],
          }
        ]
      }
      option && myChart.setOption(option)


      clearInterval(this.interval_B)
      this.interval_B = setInterval(() => {

        clearTimeout(timer)
        let timer = setTimeout(function(){

          document.getElementById('chart_B').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_B"))

          let data = [
            { value: that.Info.reviewNum },
            { value: that.Info.unReviewNum },
          ]

          option.series[0].data = data
          option && myChart.setOption(option)

        }, 100)
      }, 30000)

    },

    /**
     * @param { 日评阅量统计 }
     */    
    chart_C() {
      let that = this

      let x = []
      this.teacherInfo.xaxis.map(e=>{
        let item = e.slice(5, e.length).replace('-', '/')
        x.push(item)
      })

      let data_1 = this.teacherInfo.totalPercent
      let data_2 = this.teacherInfo.teacherPercent

      let myChart = this.$echarts.init(document.getElementById("chart_C"))
      var option = {
        grid: {
          x: 60,
          x2: 48,
          y2: 36,
        },
        legend: {
          top: 16,
          itemHeight: 10,
          itemWidth: 20,
          itemGap: 72,
          textStyle: {
            color: "#A3A7BF",
            fontSize: 14
          },

        },
        xAxis: {
          type: 'category',
          data: x
        },
        yAxis: {
          type: 'value',
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
              type: 'solid',
            }
          }
        },
        series: [
          {
            name: '平均值',
            label: {
              normal: {
                formatter: function(p) { return that.setNumber(p) }
              }
            },
            data: data_1,
            type: 'line',
            smooth: true,
            itemStyle: {
              normal: {
                color: '#05C985',
                borderColor: '#05C985',
                borderWidth: 2,
                label: {
                  position: 'top',
                  show: true,
                  color: 'rgba(255, 255, 255, 0.85)',
                }
              }
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(0,216,108,0.35)'
                    },
                    {
                      offset: 1,
                      color: 'rgba(0,216,108,0)'
                    }
                  ],
                  global: false
                }
              }
            }
          },
          {
            name: this.teacherInfo.teacherName,
            label: {
              normal: {
                formatter: function(p) { return that.setNumber(p) }
              }
            },
            data: data_2,
            type: 'line',
            smooth: true,
            itemStyle: {
              normal: {
                color: '#FFA63E',
                borderColor: '#FFA63E',
                borderWidth: 2,
                label: {
                  position: 'top',
                  show: true,
                  color: 'rgba(255, 255, 255, 0.85)',
                }
              }
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(255,166,62,0.35)'
                    },
                    {
                      offset: 1,
                      color: 'rgba(255,166,62,0)'
                    }
                  ],
                  global: false
                }
              }
            }
          },

        ]
      }
      option && myChart.setOption(option)


      clearInterval(this.interval_C)
      this.interval_C = setInterval(() => {

        clearTimeout(timer)
        let timer = setTimeout(function(){

          document.getElementById('chart_C').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_C"))

          // 参数处理
          let x = []
          that.teacherInfo.xaxis.map(e=>{
            let item = e.slice(5, e.length).replace('-', '/')
            x.push(item)
          })

          let data_1 = that.teacherInfo.totalPercent
          let data_2 = that.teacherInfo.teacherPercent

          option.xAxis.data = x
          option.series[0].data = data_1
          option.series[1].data = data_2
          option.series[1].name = that.teacherInfo.teacherName

          option && myChart.setOption(option)
        }, 2000)
      }, 30000)

    },

    /**
     * @param { 评阅分数段分布 }
     */
    chart_D() {
      let that = this

      let xData = this.data_D.xaxis
      let data_1 = this.data_D.totalPercent
      let data_2 = this.data_D.teacherPercent

      let myChart = this.$echarts.init(document.getElementById("chart_D"))
      var option = {
        grid: {
          x: 60,
          x2: 48,
          y2: 36,
        },
        legend: {
          top: 16,
          itemHeight: 10,
          itemWidth: 20,
          itemGap: 72,
          textStyle: {
            color: "#A3A7BF",
            fontSize: 14
          },

        },
        xAxis: {
          name: '分',
          nameTextStyle: {
            padding: [0, 0, 20, 0]
          },
          type: 'category',
          data: xData
        },
        yAxis: {
          splitNumber: 4,
          axisLabel: {
            formatter: `{value} %`
          },
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
              type: 'solid',
            }
          }
        },
        series: [
          {
            name: '整体分布',
            label: {
              normal: {
                formatter: `{c} %`
              }
            },
            data: data_1,
            type: 'line',
            smooth: true,
            itemStyle: {
              normal: {
                color: '#05C985',
                borderColor: '#05C985',
                borderWidth: 2,
                label: {
                  position: 'top',
                  show: true,
                  color: 'rgba(255, 255, 255, 0.85)',
                }
              }
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(0,216,108,0.35)'
                    },
                    {
                      offset: 1,
                      color: 'rgba(0,216,108,0)'
                    }
                  ],
                  global: false
                }
              }
            }
          },
          {
            name: this.data_D_name,
            label: {
              normal: {
                formatter: `{c} %`
              }
            },
            data: data_2,
            type: 'line',
            smooth: true,
            itemStyle: {
              normal: {
                color: '#FFA63E',
                borderColor: '#FFA63E',
                borderWidth: 2,
                label: {
                  position: 'top',
                  show: true,
                  color: 'rgba(255, 255, 255, 0.85)',
                }
              }
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(255,166,62,0.35)'
                    },
                    {
                      offset: 1,
                      color: 'rgba(255,166,62,0)'
                    }
                  ],
                  global: false
                }
              }
            }
          },


        ]
      }
      option && myChart.setOption(option)


      clearInterval(this.interval_D)
      this.interval_D = setInterval(() => {

        clearTimeout(timer)
        let timer = setTimeout(function(){

          document.getElementById('chart_D').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_D"))

          // 参数处理
          let xData = that.data_D.xaxis
          let data_1 = that.data_D.totalPercent
          let data_2 = that.data_D.teacherPercent

          option.xAxis.data = xData
          option.series[0].data = data_1
          option.series[1].data = data_2
          option.series[1].name = that.data_D_name

          option && myChart.setOption(option)
        }, 2000)
      }, 30000)

    },

    /**
     * @param { 评阅分配详情 }
     */  
    chart_E() {
      let that = this

      let data_1 = []
      let data_2 = []
      let x_data = []

      this.data_E[0].map(e=>{
        x_data.push(e.teacherCourseName)
        data_1.push(e.reviewCount)
        data_2.push(e.unReviewCount)
      })

      let myChart = this.$echarts.init(document.getElementById("chart_E"))
      var option = {
        grid: {
          x: 60,
          x2: 48,
          y2: 64,
        },
        legend: {
          top: 16,
          itemHeight: 8,
          itemWidth: 12,
          itemGap: 72,
          textStyle: {
            color: "#A3A7BF",
            fontSize: 14
          },

        },
        xAxis: {
          nameTextStyle: {
            padding: [0, 0, 20, 0]
          },
          axisLabel: {
            margin: 18,
            padding: [0, 0 , 0, -16],
            rotate: -20,
          },
          type: 'category',
          data: x_data
        },
        yAxis: {
          splitNumber: 4,
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
              type: 'solid',
            }
          }
        },
        series: [
          {
            name: '已评阅',
            data: data_1,
            type: 'bar',
            barWidth: '18%',
            smooth: true,
            itemStyle: {
              normal: {
                color: '#05C985',
                borderColor: '#05C985',
                barBorderRadius: [2, 2, 0, 0],
                borderWidth: 2,
                label: {
                  position: 'top',
                  show: true,
                  color: 'rgba(255, 255, 255, 0.85)',
                }
              }
            },
          },
          {
            name: '待评阅',
            data: data_2,
            type: 'bar',
            barWidth: '18%',
            smooth: true,
            itemStyle: {
              normal: {
                color: '#FFA63E',
                borderColor: '#FFA63E',
                barBorderRadius: [2, 2, 0, 0],
                borderWidth: 2,
                label: {
                  position: 'top',
                  show: true,
                  color: 'rgba(255, 255, 255, 0.85)',
                }
              }
            },
          },
        ]
      }
      option && myChart.setOption(option)


      clearInterval(this.interval_E)
      this.interval_D = setInterval(() => {

        clearTimeout(timer)
        let timer = setTimeout(function(){

          document.getElementById('chart_E').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_E"))

          that.data_E_Index++
          if ( that.data_E_Index == that.data_E.length || that.data_E_Index > that.data_E.length ) {
            that.data_E_Index = 0
          }

          let data_1 = []
          let data_2 = []
          let x_data = []

          that.data_E[that.data_E_Index].map(e=>{
            x_data.push(e.teacherCourseName)
            data_1.push(e.reviewCount)
            data_2.push(e.unReviewCount)
          })

          option.xAxis.data = x_data
          option.series[0].data = data_1
          option.series[1].data = data_2

          option && myChart.setOption(option)
        }, 100)

      }, 30000)

    },

    /**
     * @param { 评阅平均时长统计 }
     */  
    chart_F() {
      let that = this

      let xData = []
      let yData = []
      this.data_F[0].map(e=>{
        xData.push(e.teacherCourseName)
        yData.push(e.reviewDuration)
      })


      let myChart = this.$echarts.init(document.getElementById("chart_F"))
      var option = {
        grid: {
          x: 60,
          x2: 48,
          y2: 36,
        },
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: {
            show: true,
            interval: 0,
          }
        },
        yAxis: {
          splitNumber: 5,
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
              type: 'solid',
            }
          }
        },
        series: [
          {
            data: yData,
            type: 'bar',
            barWidth: '18%',
            smooth: true,
            itemStyle: {
              normal: {
                color: '#266EFF',
                borderColor: '#266EFF',
                barBorderRadius: [2, 2, 0, 0],
                borderWidth: 2,
                label: {
                  position: 'top',
                  show: true,
                  color: 'rgba(255, 255, 255, 0.85)',
                }
              }
            },

          },
        ]
      }
      option && myChart.setOption(option)

      clearInterval(this.interval_F)
      this.interval_F = setInterval(() => {

        clearTimeout(timer)
        let timer = setTimeout(function(){

          document.getElementById('chart_F').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_F"))

          // 参数处理
          that.data_F_Index++;
          if (that.data_F_Index >= that.data_F.length) {
            that.data_F_Index = 0
          }

          let xData = []
          let yData = []
          that.data_F[that.data_F_Index].map(e=>{
            xData.push(e.teacherCourseName)
            yData.push(e.reviewDuration)
          })  

          option.xAxis.data = xData
          option.series[0].data = yData

          option && myChart.setOption(option)
        }, 5000)

      }, 30000)

    },

    /**
     * @param { 评阅分数段分布 }
     */  
    chart_G() {
      let that = this

      let xData = this.data_D.xaxis
      let data_1 = this.data_D.totalPercent
      let data_2 = this.data_D.teacherPercent

      let myChart = this.$echarts.init(document.getElementById("chart_G"))
      var option = {
        grid: {
          x: 60,
          x2: 48,
          y2: 36,
        },
        legend: {
          top: 16,
          itemHeight: 10,
          itemWidth: 20,
          itemGap: 72,
          textStyle: {
            color: "#A3A7BF",
            fontSize: 14
          },

        },
        xAxis: {
          name: '分',
          nameTextStyle: {
            padding: [0, 0, 20, 0]
          },
          type: 'category',
          data: xData
        },
        yAxis: {
          splitNumber: 4,
          axisLabel: {
            formatter: `{value} %`
          },
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: '#212E71',
              width: 1,
              type: 'solid',
            }
          }
        },
        series: [
          {
            name: '整体分布',
            label: {
              normal: {
                formatter: `{c} %`
              }
            },
            data: data_1,
            type: 'line',
            smooth: true,
            itemStyle: {
              normal: {
                color: '#05C985',
                borderColor: '#05C985',
                borderWidth: 2,
                label: {
                  position: 'top',
                  show: true,
                  color: 'rgba(255, 255, 255, 0.85)',
                }
              }
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(0,216,108,0.35)'
                    },
                    {
                      offset: 1,
                      color: 'rgba(0,216,108,0)'
                    }
                  ],
                  global: false
                }
              }
            }
          },
          {
            name: this.data_D_name,
            label: {
              normal: {
                formatter: `{c} %`
              }
            },
            data: data_2,
            type: 'line',
            smooth: true,
            itemStyle: {
              normal: {
                color: '#FFA63E',
                borderColor: '#FFA63E',
                borderWidth: 2,
                label: {
                  position: 'top',
                  show: true,
                  color: 'rgba(255, 255, 255, 0.85)',
                }
              }
            },
            areaStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(255,166,62,0.35)'
                    },
                    {
                      offset: 1,
                      color: 'rgba(255,166,62,0)'
                    }
                  ],
                  global: false
                }
              }
            }
          },


        ]
      }
      option && myChart.setOption(option)

      clearInterval(this.interval_G)
      this.interval_G = setInterval(() => {

        clearTimeout(timer)
        let timer = setTimeout(function(){

          document.getElementById('chart_G').removeAttribute('_echarts_instance_')
          let myChart = that.$echarts.init(document.getElementById("chart_G"))

          // 参数处理
          let xData = that.data_D.xaxis
          let data_1 = that.data_D.totalPercent
          let data_2 = that.data_D.teacherPercent

          option.xAxis.data = xData
          option.series[0].data = data_1
          option.series[1].data = data_2
          option.series[1].name = that.data_D_name

          option && myChart.setOption(option)
        }, 2000)

      }, 30000)

    },

  },

  created() {
    this.getLogo()
    this.currentDate()
  },
  
  async mounted() {
    let that = this
    await this.getTeacherList()
    await this.initData()

    // this.interval_getTeacher = setInterval(() => {
    //   that.getTeacherList()
    // }, 60000)
    
    this.interval_initData = setInterval(() => {
      that.initData()
    }, 30000)
  },

  beforeDestroy() {
    clearInterval(this.interval_A)
    clearInterval(this.interval_B)
    clearInterval(this.interval_C)
    clearInterval(this.interval_D)
    clearInterval(this.interval_E)
    clearInterval(this.interval_F)
    clearInterval(this.interval_G)
    clearInterval(this.interval_initData)
    clearInterval(this.interval_getTeacher)
    clearInterval(this.interval_data_C)
    clearInterval(this.interval_Duration)
    clearInterval(this.interval_location)
    clearInterval(this.interval_Score)
    clearInterval(this.interval_Review)
  } 

};
</script>

<style lang="less" scoped>
[v-cloak] {
  display: none;
}
.Data_V_Border {
  width: 100vw;
  height: 100%;
  background: #00134D;
}

// Rem ==> 屏幕宽度 1/10;
#Data_V {
  width: 100vw;
  height: calc(108/198 * 10rem);
  padding: 0 0.12rem 0.12rem;
  box-sizing: border-box;
  background: #00134D;
  display: flex;
  flex-direction: column;

  .Title {
    height: calc((90/1080) * 100%);
  }

  .Top {
    height: calc((200/1080) * 100%);
  }

  .Middle {
    height: calc((40/108) * 100%);
  }

  .Bottom {
    height: calc((38/108) * 100%);
  }

  .Title,.Top,.Middle,.Bottom {
    width: 100%;
    margin-bottom: 1%;
  }

  .Title,.Bottom {
    margin: 0;
  }

  .Top {
    background: #0F1D66;
    border-radius: .03rem;
    padding: .12rem .1rem;
    box-sizing: border-box;
  }

  // Logo + Title + Date
  .Title {
    font-size: .18rem;
    font-weight: 600;
    line-height: .45rem;
    text-align: center;
    color: #FFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'PingFangSC-Semibold, PingFang SC';
    &>img {
      float: left;
      height: .18rem;
    }
    &>.Date {
      &>span:first-child {
        font-size: 0.08rem;
        font-weight: 400;
        color: rgba(255,255,255,0.85);
        margin-right: .06rem;
        font-family: 'PingFangSC-Regular, PingFang SC';
      }
      &>span:last-child {
        font-size: .1rem;
        font-weight: 600;
        color: #FFF;
        font-family: 'PingFangSC-Semibold, PingFang SC';
      }
    }
  }

  // Top
  .Top {
    .Top_title {
      display: flex;
      align-items: center;
      margin-bottom: .18rem;
      font-family: 'PingFangSC-Medium, PingFang SC';
      box-sizing: border-box;

      .title_A {
        width: .03rem;
        height: .1rem;
        margin-right: 0.03rem;

        background: #266EFF;
        border-radius: .03rem;
        border-right: 0;
      }

      .title_B {
        font-size: .11rem;
        font-weight: 500;
        line-height: .12rem;
        color: #FFF;
      }
    }

    .Top_main {
      width: 100%;
      height: .34rem;
      display: flex;
      justify-content: space-between;
      .item {
        width: 1.02rem;
        height: 100%;
        box-sizing: border-box;
      }
      .item_D {
        border-left: 1px solid rgba(255,255,255,0.12);
        .item_dule {
          text-align: center;
          &>span {
            color: #FFF;
          }
          &>span:first-child {
            font-size: .18rem;
            font-family: 'DIN-Medium, DIN';
            font-weight: 500;
            line-height: .22rem;
            margin-right: .02rem;
          }
          &>span:last-child {
            font-size: .08rem;
            line-height: 22px;
            color: #A3A7BF;
            font-family: 'PingFangSC-Regular, PingFang SC';
          }
        }
        .item_des {
          text-align: center;
          font-size: .08rem;
          font-family: 'PingFangSC-Regular, PingFang SC';
          font-weight: 400;
          color: #A3A7BF;
          line-height: .12rem;
        }
      }
      .item_D:first-child {
        border: none;
      }
    }

  }

  // Middle
  .Middle {
    display: flex;
    justify-content: space-between;

    .Left {
      width: 33%;
      box-sizing: border-box;
      .charts {
        height: 1.45rem;
        height: 100%;
        width: 100%;
        margin-top: .42rem;
        display: flex;
        justify-content: space-around;
        .chart_A {
          .info_Mob,.info_Web {
            margin-left: .06rem;
          }
        }
        .chart_B {
          .info_Mob,.info_Web {
            margin-left: .12rem;
          }          
        }
        .chart_A,.chart_B {
          width: .9rem;
          height: 100%;
          .chart_A_Border,.chart_B_Border {
            width: .9rem;
            height: .9rem;
            #chart_A,#chart_B {
              width: 100%;
              height: 100%;
            }
          }
          .info_Mob,.info_Web {
            color: #FFF;
            font-size: .07rem;
            font-family: 'PingFangSC-Regular, PingFang SC';
            display: flex;
            align-items: center;
            margin-top: .11rem;
            .dit {
              display: inline-block;
              width: .04rem;
              height: .04rem;
              margin-right: .04rem;
              border-radius: 50%;
            }
            .number {
              margin: 0 .04rem;
              font-size: .09rem;
              font-weight: 500;
              font-family: 'Futura-Medium, Futura';
            }
          }
          .info_Web {
            margin-top: .06rem;
          }
        }
      }
    }

    .Center {
      width: 33%;
      #chart_C {
        width: 100%;
        height: 100%;
        padding-top: .24rem;
        box-sizing: border-box;
      }
    }

    .Right {
      width: 33%;
      #chart_D {
        width: 100%;
        height: 100%;
        padding-top: .24rem;
        box-sizing: border-box;
      }

      .Scroll {
        width: 100%;
        height: 1.55rem;
        position: absolute;
        bottom: 0;
        padding: .11rem .15rem .075rem;
        box-sizing: border-box;
        overflow: hidden;

        .VueScoll {
          height: 100%; 
          overflow: hidden;
          ul li {
            height: .24rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: .08rem;
            font-family: 'PingFangSC-Regular, PingFang SC';
            .A {
              color: #FFF;
              opacity: .85;
              min-width: 1rem;
              width: auto;
            }
            .B {
              color: #FFF;
              opacity: .85;
              min-width: .9rem;
              width: auto;
            }
            .C {
              color: #FFF;
              opacity: .85;
              width: auto;
              text-align: right;
            }
          }
        }
      }

    }

    .Left,.Center,.Right {
      height: 100%;
      position: relative;
      background: #0F1D66;
      border-radius: .03rem;
      overflow: hidden;
      .title {
        width: 100%;
        padding-top: 24px;
        padding-left: 20px;
        padding-right: 24px;
        box-sizing: border-box;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: 'PingFangSC-Medium, PingFang SC';
        &>div {
          display: flex;
          align-items: center;
          .title_A {
            width: .03rem;
            height: .1rem;
            margin-right: 0.03rem;
            background: #266EFF;
            border-radius: .03rem;
            border-right: 0;
          }
          .title_B {
            font-size: .11rem;
            font-weight: 500;
            line-height: .12rem;
            color: #FFF;
          }
        }
        .title_C {
          font-size: .08rem;
          color: #A3A7BF;
          font-family: 'PingFangSC-Regular, PingFang SC';
          line-height: .12rem;
          float: right;
        }
      }
    }

  }

  // Bottom
  .Bottom {
    display: flex;
    justify-content: space-between;

    .Left {
      width: 33%;
      box-sizing: border-box;

      .charts {
        height: 100%;
        width: 100%;
        display: flex;

        #chart_E {
          width: 100%;
          height: 100%;
          padding-top: .24rem;
          box-sizing: border-box;
        }

      }

    }

    .Center {
      width: 33%;
      .charts {
        height: 100%;
        width: 100%;
        display: flex;
        #chart_F {
          width: 100%;
          height: 100%;
          padding-top: .16rem;
          box-sizing: border-box;
        }
      }
    }

    .Right {
      width: 33%;
      .charts {
        height: 100%;
        width: 100%;
        display: flex;
        #chart_G {
          width: 100%;
          height: 100%;
          padding-top: .16rem;
          box-sizing: border-box;
        }
      }
      .Scroll {
        width: 100%;
        height: 1.55rem;
        position: absolute;
        bottom: 0;
        padding: .11rem .15rem .075rem;
        box-sizing: border-box;
        overflow: hidden;

        .VueScoll {
          height: 100%; 
          overflow: hidden;
          ul li {
            height: .24rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: .08rem;
            font-family: 'PingFangSC-Regular, PingFang SC';
            .A {
              color: #FFF;
              opacity: .85;
              min-width: 1rem;
              width: auto;
            }
            .B {
              color: #FFF;
              opacity: .85;
              min-width: .9rem;
              width: auto;
            }
            .C {
              color: #FFF;
              opacity: .85;
              width: auto;
              text-align: right;
            }
          }
        }
      }

    }

    .Left,.Center,.Right {
      height: 100%;
      position: relative;
      background: #0F1D66;
      border-radius: .03rem;
      overflow: hidden;

      .title {
        width: 100%;

        padding-top: 24px;
        padding-left: 20px;
        padding-right: 24px;
        box-sizing: border-box;

        position: absolute;

        display: flex;
        align-items: center;
        justify-content: space-between;

        font-family: 'PingFangSC-Medium, PingFang SC';

        &>div {

          display: flex;
          align-items: center;

          .title_A {
            width: .03rem;
            height: .1rem;
            margin-right: 0.03rem;

            background: #266EFF;
            border-radius: .03rem;
            border-right: 0;
          }

          .title_B {
            font-size: .11rem;
            font-weight: 500;
            line-height: .12rem;
            color: #FFF;
          }

        }

        .title_C {
          font-size: .08rem;
          color: #A3A7BF;
          font-family: 'PingFangSC-Regular, PingFang SC';
          line-height: .12rem;
          float: right;
        }
      }

    }
  }

}
</style>
